<template>
  <div :class="$style.container">
    <div :class="$style.input">
      <capusta-input
        v-model="refund.reason"
        :label="$t('reason.for.refund')"
        :placeholder="$t('for.example.product.defect')"
      />
    </div>

    <div :class="$style.switcher">
      <cs-switcher
        v-model="refund.alert"
        :label="$t('notify.about.refund')"
      />
    </div>

    <div v-if="refund.alert" :class="$style.input">
      <capusta-input
        v-model="refund.email"
        :label="$t('email.for.notification')"
        placeholder="name@domain.ru"
      />
    </div>
  </div>
</template>

<script>
import CapustaInput from 'molecules/capusta-input/CapustaInput';

export default {
  name: 'IndicateReasonReturn',
  components: {
    CapustaInput,
  },
  data() {
    return {
      refund: {
        reason: '',
        email: '',
        alert: false,
      },
    };
  },
  watch: {
    refund: {
      deep: true,
      handler(val) {
        this.$emit('change-data', { ...val });
      },
    },
  },
};
</script>

<style lang="sass" module>
  .container

  .input

    &:not(:last-child)
      margin-bottom: 20px

  .switcher
    &:not(:last-child)
      margin-bottom: 20px
</style>
